import { render, staticRenderFns } from "./VideoPopup.vue?vue&type=template&id=17d48bc6&scoped=true&"
import script from "./VideoPopup.vue?vue&type=script&lang=js&"
export * from "./VideoPopup.vue?vue&type=script&lang=js&"
import style0 from "./VideoPopup.vue?vue&type=style&index=0&id=17d48bc6&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "17d48bc6",
  null
  
)

export default component.exports